module.exports = __webpack_public_path__ + "static/media/8.637c03ac.png";